import { useLocation } from 'react-router-dom';
import { THEME_PREVIEW_FRAME_PATH } from '@/lib/theme-presets';

/** True inside the admin theme-preview iframe (a read-only copy of the owner's homepage). */
export function useIsThemePreviewFrame() {
  const { pathname } = useLocation();
  return pathname.startsWith(THEME_PREVIEW_FRAME_PATH);
}
